import React from 'react'
import './../App.css'
import Xc47Hull from './Xc47Hull'
import { Route, Switch, Redirect } from 'react-router-dom'
import Xc47BowSprit from './Xc47BowSprit'
import Xc47HullTreatment from './Xc47HullTreatment'
import Xc47Transom from './Xc47Transom'
import Xc47Deck from './Xc47Deck'
import Xc47Sprayhood from './Xc47Sprayhood'
import Xc47Wheel from './Xc47Wheel'
import Xc47Mast from './Xc47Mast'
import Xc47Interior from './Xc47Interior'
import Xc47Galley from './Xc47Galley'
import Xc47Fabric from './Xc47Fabric'
import Xc47OwnersCabin from './Xc47OwnersCabin'
import Xc47AftCabin from './Xc47AftCabin'
import Logo from './Xc47-logo.svg'
import Xc47Summary from './Xc47Summary'
import Xc47BathingPlatform from './Xc47BathingPlatform'

import hullColor11 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x light grey RAL 7035 waterliness.jpg'
import hullColor12 from '../assets/hullColors/Hull colour -  pure white RAL 9010 & 3 x black grey RAL 702 waterlines.jpg'
import hullColor14 from '../assets/hullColors/Hull colour - light grey RAL 7035 & 3 x pure white RAL 9010 waterlines.jpg'
import hullColor15 from '../assets/hullColors/9010_5011.jpg'
import hullColor16 from '../assets/hullColors/7035_7021.jpg'

import fabric1 from '../assets/fabrics/JustFleckless–01Nature.jpg'
import fabric2 from '../assets/fabrics/JustFleckless–05Camel.jpg'
import fabric3 from '../assets/fabrics/JustFleckless–10Navy.jpg'
import fabric4 from '../assets/fabrics/JustFleckless–403Bambus.jpg'
import fabric5 from '../assets/fabrics/JustFleckless–710MoonGrey.jpg'
import fabric6 from '../assets/fabrics/JustFleckless–750OliveGrey.jpg'
import fabric7 from '../assets/fabrics/AlsaceBlue.jpg'
import fabric8 from '../assets/fabrics/AlsaceIvory.jpg'
import fabric9 from '../assets/fabrics/AlsaceSand.jpg'
import fabric10 from '../assets/fabrics/Nubilux709Argent.jpg'

import galley1 from '../assets/galleyColors/camoan_white_corian.jpg'
import galley2 from '../assets/galleyColors/black_quartz_corian.jpg'

import laminate1 from '../assets/interiorColors/teak_without_koto.jpg'
import laminate2 from '../assets/interiorColors/walnut.jpg'
import laminate3 from '../assets/interiorColors/teak_with_koto.jpg'
import laminate4 from '../assets/interiorColors/white_tinted_oak.jpg'

import veneer1 from '../assets/interiorColors/nordic_oak.jpg'
import veneer2 from '../assets/interiorColors/teak_without_koto.jpg'
import veneer3 from '../assets/interiorColors/white_tinted_oak.jpg'

import sprayhood1 from '../assets/sprayhoodColors/without.jpg'
import sprayhood2 from '../assets/sprayhoodColors/Dark grey.jpg'
import sprayhood3 from '../assets/sprayhoodColors/Taupe.jpg'
import sprayhood4 from '../assets/sprayhoodColors/Captains blue.jpg'
import sprayhood5 from '../assets/sprayhoodColors/Silver grey.jpg'

import ConfiguratorContainer from '../ConfiguratorContainer'
import { withTranslation } from 'react-i18next'

class Xc47Container extends ConfiguratorContainer {
  constructor (props) {
    super(props)

    this.logo = Logo
    this.logoLink = 'https://www.x-yachts.com/en/yachts/xc/xc47/'

    this.HullColourOptions = [
      {
        value: 1,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Light Grey (RAL 7035) integrated Gelcoat Water Lines'
        ),
        preview: hullColor11
      },
      {
        value: 2,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'
        ),
        preview: hullColor12
      },
      {
        value: 3,
        label: this.props.t('Light Grey'),
        description: this.props.t(
          '(RAL 7035) & 3 x Pure White (RAL 9010) integrated Gelcoat Water Lines'
        ),
        preview: hullColor14
      },
      {
        value: 4,
        label: this.props.t('Pure White'),
        description: this.props.t(
          '(RAL 9010) & 3 x Dark Blue (RAL 5011) integrated Gelcoat Water Lines'
        ),
        preview: hullColor15
      },
      {
        value: 5,
        label: this.props.t('Light Grey'),
        description: this.props.t(
          '(RAL 7035) & 3 x Black Grey (RAL 7021) integrated Gelcoat Water Lines'
        ),
        preview: hullColor16
      }
    ]

    this.BowSpritOptions = [
      {
        value: 1,
        label: this.props.t('Standard'),
        description: this.props.t(
          'Carbon fibre bowsprit in hull colour painted carbon fibre for asymmetric spinnaker (accommodates the standard stainless steel anchor roller)'
        )
      }
    ]

    this.HullTreatmentOptions = [
      { value: 1, label: this.props.t('White') },
      { value: 2, label: this.props.t('Copper') },
      { value: 3, label: this.props.t('Grey') }
    ]

    this.DeckOptions = [
      { value: 1, label: this.props.t('Genuine teak with black caulkings') },
      { value: 2, label: this.props.t('Flexiteek with grey stripes') }
    ]

    this.MastAndBoomOptions = [
      { value: 1, label: this.props.t('Aluminium') },
      { value: 2, label: this.props.t('White painted carbon') },
      { value: 3, label: this.props.t('Black painted carbon') },
      { value: 4, label: this.props.t('Clear coated carbon') }
    ]

    this.WheelOptions = [
      {
        value: 1,
        label: this.props.t('Steel Wheel with leather covered rim'),
        description: this.props.t('(standard)')
      },
      { value: 2, label: this.props.t('Black Composite wheel') },
      {
        value: 3,
        label: this.props.t(
          'White composite wheels with laminated unvarnished teak rim'
        )
      }
    ]

    this.SprayhoodOptions = [
      { value: 1, label: this.props.t('Without'), thumbnail: sprayhood1 },
      { value: 2, label: this.props.t('Dark grey'), thumbnail: sprayhood2 },
      { value: 3, label: this.props.t('Taupe'), thumbnail: sprayhood3 },
      { value: 4, label: this.props.t('Captains blue'), thumbnail: sprayhood4 },
      { value: 5, label: this.props.t('Silver grey'), thumbnail: sprayhood5 }
    ]

    this.BoomCoverOptions = this.SprayhoodOptions

    this.BoomOptions = [
      { value: 1, label: this.props.t('O-Furling boom *') },
      { value: 2, label: this.props.t('V-furling boom *') },
      { value: 3, label: this.props.t('Carbon mast & boom *') },
      { value: 4, label: this.props.t('V-Carbon boom *') }
    ]

    this.VeneerOptions = [
      { value: 1, label: this.props.t('Nordic Oak'), thumbnail: veneer1 },
      { value: 2, label: this.props.t('Modern Teak'), thumbnail: veneer2 },
      { value: 3, label: this.props.t('Tinted oak'), thumbnail: veneer3 }
    ]

    this.FloorboardOptions = [
      {
        value: 1,
        label: this.props.t('Teak laminate (standard)'),
        thumbnail: laminate1
      },
      {
        value: 2,
        label: this.props.t('Walnut laminate (optional)'),
        thumbnail: laminate2
      },
      {
        value: 3,
        label: this.props.t('Teak with inlay stripes / holly (optional)'),
        thumbnail: laminate3
      },
      { value: 4, label: this.props.t('Tinted oak'), thumbnail: laminate4 }
    ]

    this.FabricOptions = [
      {
        value: 1,
        label: this.props.t('Just Fleckless – 01 Nature'),
        thumbnail: fabric1
      },
      {
        value: 2,
        label: this.props.t('Just Fleckless – 05 Camel'),
        thumbnail: fabric2
      },
      {
        value: 3,
        label: this.props.t('Just Fleckless – 10 Navy'),
        thumbnail: fabric3
      },
      {
        value: 4,
        label: this.props.t('Just Fleckless – 403 Bambus'),
        thumbnail: fabric4
      },
      {
        value: 5,
        label: this.props.t('Just Fleckless – 710 Moon Grey'),
        thumbnail: fabric5
      },
      {
        value: 6,
        label: this.props.t('Just Fleckless – 750 Olive Grey'),
        thumbnail: fabric6
      },
      { value: 7, label: this.props.t('Alsace Blue'), thumbnail: fabric7 },
      { value: 8, label: this.props.t('Alsace Ivory'), thumbnail: fabric8 },
      { value: 9, label: this.props.t('Alsace Sand'), thumbnail: fabric9 },
      {
        value: 10,
        label: this.props.t('Nubilux 709 Argent'),
        thumbnail: fabric10
      }
    ]

    this.WorktopOptions = [
      {
        value: 1,
        label: this.props.t('Worktop in Camoan white Corian (standard)'),
        thumbnail: galley1
      },
      {
        value: 2,
        label: this.props.t('Worktop in black quartz Corian'),
        thumbnail: galley2
      }
    ]

    this.AftCabinLayoutOptions = [
      { value: 1, label: this.props.t('Double Berth') },
      {
        value: 2,
        label: this.props.t('Double Berth and Freeboard hung sea berths')
      },
      { value: 3, label: this.props.t('Double Berth and Upper cabinets') },
      { value: 4, label: this.props.t('Split Berth') },
      {
        value: 5,
        label: this.props.t('Split Berth and Freeboard hung sea berths')
      },
      { value: 6, label: this.props.t('Split Berth and Upper cabinets') }
    ]

    this.WardrobeOptions = [
      {
        value: 1,
        label: this.props.t('Large wardrobe to starboard (standard)'),
        thumbnail: laminate1
      },
      {
        value: 2,
        label: this.props.t(
          'Seat to starboard and storage under neath with medium wardrobe'
        ),
        thumbnail: laminate2
      }
    ]

    const defaultHullColour = this.HullColourOptions[0]
    const defaultTransomColor = this.getTransomColorByHullColourValue(
      defaultHullColour.value
    )

    this.state = Object.assign(this.state, {
      boat: 'Xc47',
      exterior: {
        HullColour: defaultHullColour,
        BowSprit: this.BowSpritOptions[0],
        HullTreatment: this.HullTreatmentOptions[0],
        Deck: this.DeckOptions[0],
        TeakOnSideDecks: { value: 2, label: 'true' },
        TeakOnCoachroof: { value: 2, label: 'true' },
        SolarPanels: { value: 1, label: 'false' },
        DavidsRib: { value: 1, label: 'false' },
        RemovableGangway: { value: 1, label: 'false' },
        MastAndBoom: this.MastAndBoomOptions[0],
        Wheel: this.WheelOptions[0],
        SprayHood: this.SprayhoodOptions[0],
        BoomCover: this.BoomCoverOptions[0],
        Boom: this.BoomOptions[0]
      },
      transom: {
        Name: {
          verticalOffset: 250,
          color: defaultTransomColor,
          value: 'My yacht',
          font: this.fontOptions[0],
          size: this.sizeOptions[2],
          horizontalOffset: 0
        },
        Port: {
          verticalOffset: 500,
          color: defaultTransomColor,
          value: 'Port',
          font: this.fontOptions[0],
          size: this.sizeOptions[1],
          horizontalOffset: 0
        }
      },
      interior: {
        Veneer: this.VeneerOptions[0],
        Floorboard: this.FloorboardOptions[0],
        Fabric: this.FabricOptions[0],
        Worktop: this.WorktopOptions[0],
        FabricOwnersCabin: this.FabricOptions[0],
        CupboardsOwnersCabin: { value: 1, label: 'false' },
        BedsideCompartment: { value: 1, label: 'false' },
        Wardrobe: this.WardrobeOptions[0],
        AftCabinLayout: this.AftCabinLayoutOptions[0],
        Mast: this.MastAndBoomOptions[0],
        Wheel: this.WheelOptions[0],
        FabricSeatOwnersCabin: this.FabricOptions[0],
        FabricFreehung: this.FabricOptions[0]
      }
    })

    this.steps = [
      { name: this.props.t('Hull colourways'), url: '/Xc47/hull' },
      { name: this.props.t('Bowsprit'), url: '/Xc47/bowsprit' },
      { name: this.props.t('Hull treatment'), url: '/Xc47/hulltreatment' },
      { name: this.props.t('Deck'), url: '/Xc47/deck' },
      { name: this.props.t('Bathing platform'), url: '/Xc47/bathingplatform' },
      { name: this.props.t('Boat name'), url: '/Xc47/transom' },
      { name: this.props.t('Mast and boom'), url: '/Xc47/mast' },
      { name: this.props.t('Wheels'), url: '/Xc47/wheel' },
      { name: this.props.t('Sprayhood & Boom Cover'), url: '/Xc47/sprayhood' },

      { name: this.props.t('Interior surfaces'), url: '/Xc47/surfaces' },
      { name: this.props.t('Interior Fabric'), url: '/Xc47/fabric' },
      { name: this.props.t('Galley'), url: '/Xc47/galley' },
      { name: this.props.t("Owner's cabin"), url: '/Xc47/ownerscabin' },
      { name: this.props.t('Aft cabins'), url: '/Xc47/aftcabin' },

      { name: this.props.t('Summary'), url: '/Xc47/summary' }
    ]

    this.handleHullConfigurationChange =
      this.handleHullConfigurationChange.bind(this)
  }

  handleHullConfigurationChange (newConfiguration) {
    let transom = this.state.transom
    const transomColor = this.getTransomColorByHullColourValue(
      newConfiguration.HullColour.value
    )
    transom.Name.color = transomColor
    transom.Port.color = transomColor

    super.handleTransomChange(transom)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  getTransomColorByHullColourValue (hullColourValue) {
    switch (hullColourValue) {
      case 1:
        return this.colorOptions[6]
      case 2:
        return this.colorOptions[3]
      case 3:
        return this.colorOptions[4]
      case 4:
      case 5:
        return this.colorOptions[1]
      default:
        return this.colorOptions[6]
    }
  }

  handleExteriorConfigurationChange (newConfiguration) {
    let interior = this.state.interior
    interior.Mast = newConfiguration.MastAndBoom
    interior.Wheel = newConfiguration.Wheel

    super.handleInteriorConfigurationChange(interior)
    super.handleExteriorConfigurationChange(newConfiguration)
  }

  generateCode () {
    let data = []
    data.push('Xc47')

    data.push([])
    let exterior = this.state.exterior
    for (const key in exterior) {
      if (exterior.hasOwnProperty(key)) {
        let element = exterior[key].value
        data[data.length - 1].push(element)
      }
    }

    let transom = this.state.transom
    data.push([
      [
        transom.Name.value,
        transom.Name.font.value,
        transom.Name.size.value,
        transom.Name.color.value,
        transom.Name.horizontalOffset,
        transom.Name.verticalOffset
      ],
      [
        transom.Port.value,
        transom.Port.font.value,
        transom.Port.size.value,
        transom.Port.color.value,
        transom.Port.horizontalOffset,
        transom.Port.verticalOffset
      ]
    ])

    data.push([])
    let interior = this.state.interior
    for (const key in interior) {
      if (interior.hasOwnProperty(key)) {
        let element = interior[key].value
        data[data.length - 1].push(element)
      }
    }

    var json = JSON.stringify(data)
    return btoa(json)
  }

  parseCode (code) {
    let json = JSON.parse(atob(code))

    if (json[0] !== 'Xc47') {
      return
    }

    let exterior = this.state.exterior
    exterior.HullColour =
      this.HullColourOptions.find(v => v.value === json[1][0]) ||
      this.HullColourOptions[0]
    exterior.BowSprit =
      this.BowSpritOptions.find(v => v.value === json[1][1]) ||
      this.BowSpritOptions[0]
    exterior.HullTreatment =
      this.HullTreatmentOptions.find(v => v.value === json[1][2]) ||
      this.HullTreatmentOptions[0]
    exterior.Deck =
      this.DeckOptions.find(v => v.value === json[1][3]) || this.DeckOptions[0]
    exterior.TeakOnSideDecks = { value: +json[1][4] || 1, label: '' }
    exterior.TeakOnCoachroof = { value: +json[1][5] || 1, label: '' }
    exterior.SolarPanels = { value: +json[1][6] || 1, label: '' }
    exterior.DavidsRib = { value: +json[1][7] || 1, label: '' }
    exterior.RemovableGangway = { value: +json[1][8] || 1, label: '' }
    exterior.MastAndBoom =
      this.MastAndBoomOptions.find(v => v.value === json[1][9]) ||
      this.MastAndBoomOptions[0]
    exterior.Wheel =
      this.WheelOptions.find(v => v.value === json[1][10]) ||
      this.WheelOptions[0]
    exterior.SprayHood =
      this.SprayhoodOptions.find(v => v.value === json[1][11]) ||
      this.SprayhoodOptions[0]
    exterior.BoomCover =
      this.BoomCoverOptions.find(v => v.value === json[1][12]) ||
      this.BoomCoverOptions[0]
    exterior.Boom =
      this.BoomOptions.find(v => v.value === json[1][13]) ||
      this.BoomCoverOptions[0]

    let transom = this.state.transom
    transom.Name.value = json[2][0][0] || ''
    transom.Name.font =
      this.fontOptions.find(v => v.value === json[2][0][1]) ||
      this.fontOptions[0]
    transom.Name.size =
      this.sizeOptions.find(v => v.value === json[2][0][2]) ||
      this.sizeOptions[0]
    transom.Name.color =
      this.colorOptions.find(v => v.value === json[2][0][3]) ||
      this.colorOptions[0]
    transom.Name.horizontalOffset = +json[2][0][4] || 1
    transom.Name.verticalOffset = +json[2][0][5] || 1

    transom.Port.value = json[2][1][0] || ''
    transom.Port.font =
      this.fontOptions.find(v => v.value === json[2][1][1]) ||
      this.fontOptions[0]
    transom.Port.size =
      this.sizeOptions.find(v => v.value === json[2][1][2]) ||
      this.sizeOptions[0]
    transom.Port.color =
      this.colorOptions.find(v => v.value === json[2][1][3]) ||
      this.colorOptions[0]
    transom.Port.horizontalOffset = +json[2][1][4] || 1
    transom.Port.verticalOffset = +json[2][1][5] || 1

    let interior = this.state.interior
    interior.Veneer =
      this.VeneerOptions.find(v => v.value === json[3][0]) ||
      this.VeneerOptions[0]
    interior.Floorboard =
      this.FloorboardOptions.find(v => v.value === json[3][1]) ||
      this.FloorboardOptions[0]
    interior.Fabric =
      this.FabricOptions.find(v => v.value === json[3][2]) ||
      this.FabricOptions[0]
    interior.Worktop =
      this.WorktopOptions.find(v => v.value === json[3][3]) ||
      this.WorktopOptions[0]
    interior.FabricOwnersCabin =
      this.FabricOptions.find(v => v.value === json[3][4]) ||
      this.FabricOptions[0]
    interior.CupboardsOwnersCabin = { value: +json[3][5] || 1, label: '' }
    interior.BedsideCompartment = { value: +json[3][6] || 1, label: '' }
    interior.Wardrobe =
      this.WardrobeOptions.find(v => v.value === json[3][7]) ||
      this.WardrobeOptions[0]
    interior.AftCabinLayout =
      this.AftCabinLayoutOptions.find(v => v.value === json[3][8]) ||
      this.AftCabinLayoutOptions[0]
    interior.Mast =
      this.MastAndBoomOptions.find(v => v.value === json[3][9]) ||
      this.MastAndBoomOptions[0]
    interior.Wheel =
      this.WheelOptions.find(v => v.value === json[3][10]) ||
      this.WheelOptions[0]
    interior.FabricSeatOwnersCabin =
      this.FabricOptions.find(v => v.value === json[3][11]) ||
      this.FabricOptions[0]
    interior.FabricFreehung =
      this.FabricOptions.find(v => v.value === json[3][12]) ||
      this.FabricOptions[0]

    this.setState(this.state)
  }

  renderSteps () {
    return (
      <Switch location={this.props.location}>
        <Route exact path='/Xc47' render={() => <Redirect to='/Xc47/hull' />} />

        <Route
          path='/Xc47/hull'
          render={props => (
            <Xc47Hull
              {...props}
              onChange={this.handleHullConfigurationChange}
              onCodeSubmitted={this.parseCode}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullColourOptions={this.HullColourOptions}
            />
          )}
        />
        <Route
          path='/Xc47/bowsprit'
          render={props => (
            <Xc47BowSprit
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              bowSpritOptions={this.BowSpritOptions}
            />
          )}
        />
        <Route
          path='/Xc47/hulltreatment'
          render={props => (
            <Xc47HullTreatment
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              hullTreatmentOptions={this.HullTreatmentOptions}
            />
          )}
        />
        <Route
          path='/Xc47/transom'
          render={props => (
            <Xc47Transom
              {...props}
              onChange={this.handleTransomChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              fontOptions={this.fontOptions}
              sizeOptions={this.sizeOptions}
              colorOptions={this.colorOptions}
            />
          )}
        />
        <Route
          path='/Xc47/deck'
          render={props => (
            <Xc47Deck
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              deckOptions={this.DeckOptions}
            />
          )}
        />
        <Route
          path='/Xc47/bathingplatform'
          render={props => (
            <Xc47BathingPlatform
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
            />
          )}
        />
        <Route
          path='/Xc47/sprayhood'
          render={props => (
            <Xc47Sprayhood
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              sprayhoodOptions={this.SprayhoodOptions}
              boomCoverOptions={this.BoomCoverOptions}
            />
          )}
        />
        <Route
          path='/Xc47/wheel'
          render={props => (
            <Xc47Wheel
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              wheelOptions={this.WheelOptions}
            />
          )}
        />
        <Route
          path='/Xc47/mast'
          render={props => (
            <Xc47Mast
              {...props}
              onChange={this.handleExteriorConfigurationChange}
              configuration={this.state.exterior}
              transom={this.state.transom}
              mastAndBoomOptions={this.MastAndBoomOptions}
              boomOptions={this.BoomOptions}
            />
          )}
        />
        <Route
          path='/Xc47/surfaces'
          render={props => (
            <Xc47Interior
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              VeneerOptions={this.VeneerOptions}
              floorboardOptions={this.FloorboardOptions}
            />
          )}
        />
        <Route
          path='/Xc47/fabric'
          render={props => (
            <Xc47Fabric
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              fabricOptions={this.FabricOptions}
            />
          )}
        />
        <Route
          path='/Xc47/galley'
          render={props => (
            <Xc47Galley
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              worktopOptions={this.WorktopOptions}
            />
          )}
        />
        <Route
          path='/Xc47/aftcabin'
          render={props => (
            <Xc47AftCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              configuration={this.state.interior}
              aftCabinOptions={this.AftCabinLayoutOptions}
            />
          )}
        />
        <Route
          path='/Xc47/ownerscabin'
          render={props => (
            <Xc47OwnersCabin
              {...props}
              onChange={this.handleInteriorConfigurationChange}
              fabricOptions={this.FabricOptions}
              WardrobeOptions={this.WardrobeOptions}
              configuration={this.state.interior}
            />
          )}
        />

        <Route
          path='/Xc47/summary'
          render={props => (
            <Xc47Summary
              {...props}
              country={this.state.country}
              countries={this.state.countries}
              code={this.generateCode()}
              configuration={{
                exterior: this.state.exterior,
                interior: this.state.interior,
                transom: this.state.transom
              }}
            />
          )}
        />
      </Switch>
    )
  }
}

export default withTranslation()(Xc47Container)



// WEBPACK FOOTER //
// ./src/Xc47/Xc47Container.js